import { useTranslation } from "react-i18next";
import UiSection from "../box/UiSection";
import { ProductHightlight } from "./ProductHightlight";
import { ProductHowToUse } from "./ProductHowToUse";
import { ProductNote } from "./ProductNote";
import { RichTextBox } from "../richtext/RichTextBox";
import { ProductOperatingInfo } from "./ProductOperatingInfo";

export const ProductMoreInfo = ({ d }: { d?: ProductDetailResponse }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Guide tour only */}
      <ProductHightlight d={d} />
      {d?.scheduleImg && (
        <UiSection title={t("Schedule")}>
          <img src={d?.scheduleImg} className="w-full" alt="Schedule" />
        </UiSection>
      )}

      {/* Musical only */}
      {d?.locationInstruction?.[0]?.src && (
        <UiSection title={t("Location Instruction")}>
          <img
            src={d?.locationInstruction?.[0]?.src}
            className="w-full"
            alt="Location Instruction"
          />
        </UiSection>
      )}

      <ProductOperatingInfo d={d} />
      <ProductHowToUse d={d} />
      <ProductNote d={d} />
    </>
  );
};
